import { render, staticRenderFns } from "./RecipeCostRegistration.vue?vue&type=template&id=afdbed9e&scoped=true"
import script from "./RecipeCostRegistration.vue?vue&type=script&lang=js"
export * from "./RecipeCostRegistration.vue?vue&type=script&lang=js"
import style0 from "./RecipeCostRegistration.vue?vue&type=style&index=0&id=afdbed9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdbed9e",
  null
  
)

export default component.exports